import {
	IonApp,
	IonContent,
	IonInfiniteScroll,
	IonInfiniteScrollContent,
	IonPage,
} from "@ionic/react";
import BackButton from "components/mobile-components/Common/BackButton";
import NavFooter from "components/mobile-components/Common/NavFooter";
import Banner from "components/mobile-components/ProductDetails/Banner";
import SuppliersDetails from "components/mobile-components/SuppliersDetails/SuppliersDetails";
import { BUSINESS_TYPE_INFO } from "data/businessTypeImage";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Product from "services/Product";
import Supplier from "services/Supplier";

export default function SuppliersDetailsPage() {
	let { id } = useParams();
	const [product, setProduct] = useState([]);
	const [supplierInfo, setSupplierInfo] = useState([]);
	const [initHeight] = useState(72);
	const [initStickyClass, setInitStikyClass] = useState("");
	const [productCount, setProductCount] = useState("");
	const [productBrands, setProductBrands] = useState([]);
	const [searchQ, setSearchQ] = useState("");
	const [selectedBrand, setSelectedBrand] = useState("");
	const [sellerProductLoader, setSellerProductLoader] = useState(false);
	const [pageCount, setPageCount] = useState(2);
	const [metaCount, setMetaCount] = useState(30);
	const ekkLanguage = useSelector((state) => state.lan.lan);
	const [tempSearchParams, setTempSearchParams] = useState(false);
	const [hasMoreData, setHasMoreData] = useState(true);
	const [reachedEnd, setReachedEnd] = useState(false);

	const [supplier360, setSupplier360] = useState([]);

	const getSupplier360 = async () => {
		let response = await Supplier.getSupplier360(id);
		if (response.status === 200) {
			setSupplier360(response.data);
		}
	};

	let businessType = () =>
		BUSINESS_TYPE_INFO.find((el) => el.type === supplierInfo?.business_type);
	//get brand data
	let supplierData = async () => {
		let response = await Supplier.singleSupplierDetails(id);
		if (response.status === 200) {
			setSupplierInfo(response.results);
		} else {
		}
	};
	useEffect(() => {
		supplierData();
		getSupplier360();
	}, []);

	let getAllProduct = async () => {
		setSellerProductLoader(true);
		setSelectedBrand("");
		setProduct([]);
		if (searchQ) {
			let response = await Product.sellerProductSearch(id, searchQ);
			if (response.status === 200) {
				setProduct(response.results);
				setProductCount(response?.meta);
				setSellerProductLoader(false);
			} else {
				setSellerProductLoader(false);
			}
		} else {
			let response = await Supplier.supplierProducts(id);
			if (response.status === 200) {
				setProduct(response.results);
				setProductCount(response?.meta);
				setSellerProductLoader(false);
			} else {
				setSellerProductLoader(false);
			}
		}
	};

	//get suppliers data
	let productData = async () => {
		setSellerProductLoader(true);
		if (searchQ) {
			let response = await Product.sellerProductSearch(id, searchQ);
			if (response.status === 200) {
				setProduct(response.results);
				setProductCount(response?.meta);
				setSellerProductLoader(false);
			} else {
				setSellerProductLoader(false);
			}
		} else {
			if (selectedBrand) {
				const response = await Product.singleBrandProducts(
					selectedBrand,
					id
				);
				if (response.status === 200) {
					setProduct(response?.results);
					setSellerProductLoader(false);
					setProductCount(response?.meta);
				} else {
					setSellerProductLoader(false);
				}
			} else {
				let response = await Supplier.supplierProducts(id);
				if (response.status === 200) {
					setProduct(response.results);
					setProductCount(response?.meta);
					setSellerProductLoader(false);
				} else {
					setSellerProductLoader(false);
				}
			}
		}
	};
	// useEffect(() => {
	// 	productData();
	// }, []);

	const contentRef = useRef();
	let settinges = {
		nameShow: false,
		titleShow: true,
		skuShow: false,
		priceShow: true,
		oldPriceShow: false,
		distShow: false,
		profitShow: false,
		sellPriceShow: false,
		supplierNameShow: false,
		link: "product-details",
	};

	let slideData = supplierInfo?.images?.length
		? [...supplierInfo.images]
		: ["/assets/images/supplier_big_default.png"];
	console.log(slideData);
	let supplierImage = supplierInfo?.business_type?.image
		? [supplierInfo.business_type?.image]
		: [`/${businessType()?.image}`];

	async function getProductBrands() {
		try {
			const response = await Product.productBrands(id);
			if (response.status === 200) {
				setProductBrands(response.results);
			}
		} catch (error) {
			console.log(error);
		}
	}

	async function getProductsFromBrands(Bid) {
		setPageCount(2);
		setSellerProductLoader(true);
		setSelectedBrand(Bid);
		setProduct([]);
		try {
			if (searchQ) {
				let response = await Product.singleProductSearch(Bid, id, searchQ);
				if (response.status === 200) {
					setProduct(response.results);
					setSellerProductLoader(false);
				} else {
					setSellerProductLoader(false);
				}
			} else {
				const response = await Product.singleBrandProducts(Bid, id);
				if (response.status === 200) {
					setProduct(response?.results);
					setSellerProductLoader(false);
				} else {
					setSellerProductLoader(false);
				}
			}
		} catch (error) {
			console.log(error);
		}
	}
	useEffect(() => {
		getProductBrands();
	}, []);

	async function singleProductSearch() {
		setHasMoreData(true);
		setReachedEnd(false);
		setTempSearchParams(searchQ);
		setPageCount(2);
		try {
			let response;
			if (selectedBrand) {
				response = await Product.singleProductSearch(
					selectedBrand,
					id,
					searchQ
				);
			} else {
				response = await Product.sellerProductSearch(id, searchQ);
			}

			if (response.status === 200) {
				setProduct(response.results);
			}
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		if (searchQ === "") {
			productData();
			setTempSearchParams("");
		}
	}, [searchQ]);

	let lodeMoreData = async () => {
		if (hasMoreData) {
			if (searchQ) {
				if (selectedBrand) {
					let response = await Product.singleProductSearch(
						selectedBrand,
						id,
						searchQ,
						pageCount
					);
					if (response.status === 200) {
						if (response.results.length > 0) {
							setPageCount((prev) => prev + 1);
							setProduct([...product, ...response.results]);
							setMetaCount(response.count);
						} else {
							setHasMoreData(false);
						}
					} else {
						setHasMoreData(false);
					}
				} else {
					let response = await Product.sellerProductSearch(
						id,
						searchQ,
						pageCount
					);
					if (response.status === 200) {
						if (response.results.length > 0) {
							setPageCount((prev) => prev + 1);
							setProduct([...product, ...response.results]);
							setMetaCount(response.count);
						} else {
							setHasMoreData(false);
						}
					} else {
						setHasMoreData(false);
					}
				}
			} else {
				if (selectedBrand) {
					const response = await Product.singleBrandProducts(
						selectedBrand,
						pageCount
					);
					if (response.status === 200) {
						if (response.results.length > 0) {
							setPageCount((prev) => prev + 1);
							setProduct([...product, ...response.results]);
							setMetaCount(response.count);
						} else {
							setHasMoreData(false);
						}
					} else {
						setHasMoreData(false);
					}
				} else {
					let response = await Supplier.supplierProducts(id, pageCount);
					if (response.status === 200) {
						if (response.results.length > 0) {
							setPageCount((prev) => prev + 1);
							setProduct([...product, ...response.results]);
							setMetaCount(response.count);
						} else {
							setHasMoreData(false);
						}
					} else {
						setHasMoreData(false);
					}
				}
			}
		}
	};

	return (
		<IonApp>
			<IonPage>
				<IonContent
					style={{ "--background": "#F2F3F7" }}
					scrollEvents={true}
					ref={contentRef}
					onIonScroll={async (ev) => {
						const scrollPosition = ev.detail.scrollTop;
						if (scrollPosition > initHeight) {
							setInitStikyClass("issticky");
						} else {
							setInitStikyClass("");
						}
					}}>
					<BackButton sticky={initStickyClass} />
					<Banner
						serverImsge={supplierInfo?.images?.length}
						slideData={slideData}
						supplierInfo={supplierInfo}
						identity='seller'
						supplierImage={supplierImage}
					/>
					<SuppliersDetails
						supplierInfo={supplierInfo}
						product={product}
						settinges={settinges}
						productCount={productCount}
						productBrands={productBrands}
						getProductBrands={productData}
						getProductsFromBrands={getProductsFromBrands}
						setSearchQ={setSearchQ}
						searchQ={searchQ}
						singleProductSearch={singleProductSearch}
						setSelectedBrand={setSelectedBrand}
						sellerProductLoader={sellerProductLoader}
						getAllProduct={getAllProduct}
						tempSearchParams={tempSearchParams}
						setTempSearchParams={setTempSearchParams}
						customer={supplier360}
						setHasMoreData={setHasMoreData}
						setReachedEnd={setReachedEnd}
					/>
					<IonInfiniteScroll
						onIonInfinite={(ev) => {
							if (reachedEnd) {
								ev.target.complete();
								return;
							}
							lodeMoreData();
							setTimeout(() => {
								ev.target.complete();
								if (!hasMoreData) {
									setReachedEnd(true);
								}
							}, 500);
						}}>
						<IonInfiniteScrollContent
							loadingText={ekkLanguage.orderList.loader}
							loadingSpinner={
								hasMoreData ? "bubbles" : null
							}></IonInfiniteScrollContent>
					</IonInfiniteScroll>
				</IonContent>
				{/* <NavFooter /> */}
			</IonPage>
		</IonApp>
	);
}
